var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",attrs:{"text":"","icon":"","color":"blue lighten-2"},nativeOn:{"click":function($event){return _vm.pressed.apply(null, arguments)}}},[_c('v-icon',[_vm._v("fa-solid fa-arrows-rotate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }